"use client";
import React, { useState, useEffect } from "react";
import NoInternet from "../no-internet/page";

const NoInternetWrapper: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [isOnline, setIsOnline] = useState(true);
  const [isMounted, setIsMounted] = useState(false);

  const checkInternetConnection = async () => {
    try {
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 3000);

      const response = await fetch("/favicon.ico", {
        method: "HEAD",
        cache: "no-store",
        signal: controller.signal,
      });
      clearTimeout(timeoutId);
      setIsOnline(response.ok);
    } catch (error) {
      setIsOnline(false);
    }
  };

  useEffect(() => {
    setIsMounted(true);

    const handleOnline = () => checkInternetConnection();
    const handleOffline = () => setIsOnline(false);

    // Initial check if browser reports online
    if (navigator.onLine) {
      checkInternetConnection();
    } else {
      setIsOnline(false);
    }

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  if (!isMounted) {
    return null;
  }

  return isOnline ? <>{children}</> : <NoInternet checkInternetConnection={checkInternetConnection} />;
};

export default NoInternetWrapper;
